import type { TileCatalogPayload } from "@west-marches/shared";
import { resolveTileAssetUrl } from "@west-marches/shared";

import type { TileCatalogBrowserSection } from "./tileCatalogBrowserSections";

export function createTileCatalogSectionThumbnailResolver(payload: TileCatalogPayload) {
  const tileSetById = new Map(payload.manifest.tileSets.map((tileSet) => [tileSet.id, tileSet] as const));
  const tileUrlById = new Map(
    payload.manifest.tiles.map((tile) => [tile.id, resolveTileAssetUrl(tile.relativePath)] as const),
  );
  const decorationUrlById = new Map(
    payload.browse.decorations.map(
      (decoration) => [decoration.id, resolveTileAssetUrl(decoration.relativePath)] as const,
    ),
  );

  return function getSectionThumbnail(section: TileCatalogBrowserSection): string {
    if (section.kind === "taxonomy" && section.nodeKind === "overlay") {
      for (const decorationId of section.decorationIds ?? []) {
        const url = decorationUrlById.get(decorationId);
        if (url) {
          return url;
        }
      }
      return "";
    }

    for (const tileSetId of section.tileSetIds) {
      const tileId = tileSetById.get(tileSetId)?.tileIds[0];
      if (!tileId) {
        continue;
      }
      const url = tileUrlById.get(tileId);
      if (url) {
        return url;
      }
    }

    return "";
  };
}
